import { Button, Input, message } from 'antd'
import React from 'react'
import './index.sass'
import api from '../../../../utils/api';

const { TextArea } = Input;

export default class CreateChannel extends React.Component {
    constructor(props) {
        super(props)
        console.log(props)
        this.state = {
            channel_name: props.channelType ? props.channelType.name : '',
            channel_desc: props.channelType ? props.channelType.desc : '',
            channelType: props.channelType ? props.channelType : null
        }
    }

    componentDidMount() {

    }

    closeHandle = () => {
        this.props.colsePop(true)
    }

    addChannels = async () => {

        let { channel_name, channel_desc } = this.state

        if (!channel_name) return message.error('请填写渠道名称')

        let param = {
            name: channel_name,
            desc: channel_desc
        }


        let res = await api('add-channels', param);
        if (res.code === 200) {
            message.success(res.message)
            this.props.update(true)
            this.closeHandle()
        } else {
            message.error(res.message)
        }

        console.log(res)
    }


    changeChannels = async (ctx) => {
        let { channel_name, channel_desc } = this.state

        let param = {
            name: channel_name,
            desc: channel_desc,
            channel_id: this.props.channelType.id
        }

        let res = await api('update-channel', param);

        if (res.code === 200) {
            message.success('修改成功！')
            this.props.update(true)
            this.closeHandle();
        } else {
            message.error(res.message)
        }

        console.log(res)
    }

    render() {

        let { channelType, channel_name, channel_desc } = this.state;



        return (
            <div className='createChannel'>
                <div className='close'></div>
                <div className='popBox'>
                    <div className='title'>
                        {channelType ? '编辑渠道' : '新增渠道'}
                    </div>
                    <div className='popContent'>
                        <div className='line flex'>
                            <label>渠道名称：</label>
                            <Input value={channel_name} onChange={(e) => { this.setState({ channel_name: e.target.value }) }} placeholder='请输入' />
                        </div>

                        <div className='line flex'>
                            <label>渠道备注：</label>
                            <TextArea value={channel_desc} onChange={(e) => { this.setState({ channel_desc: e.target.value }) }} placeholder='渠道备注' showCount maxLength={50} />
                        </div>

                        <div className='flex contrlBtn'>

                            <Button onClick={() => { this.closeHandle() }}>取消</Button>



                            {
                                channelType ? (<Button onClick={() => { this.changeChannels(channelType) }}>修改</Button>) : (<Button onClick={() => { this.addChannels() }}>确定</Button>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}